import clone from 'ramda/src/clone';
import curry from 'ramda/src/curry';
import flatten from 'ramda/src/flatten';
import forEachObjIndexed from 'ramda/src/forEachObjIndexed';
import groupBy from 'ramda/src/groupBy';
import pathOr from 'ramda/src/pathOr';
import pipe from 'ramda/src/pipe';
import pluck from 'ramda/src/pluck';
export var markDecisionsRequiringAffectedServicesResolutionAsResolved = function markDecisionsRequiringAffectedServicesResolutionAsResolved(decisionsRequiringAffectedServicesResolution) {
  return decisionsRequiringAffectedServicesResolution.map(function (decision) {
    return Object.assign({}, decision.asMutable(), {
      resolved: true
    });
  });
};

// Pipe functions for duplicatedServiceIdentifierAttributes
var filterNonEmptyServiceIdentifiers = function filterNonEmptyServiceIdentifiers(attributes) {
  return attributes.filter(function (attribute) {
    var formValue = pathOr('', ['formValue'], attribute);
    return attribute.serviceIdentifier && formValue.trim() !== '';
  });
};
var pluckBy = curry(function (type, array) {
  return pluck(type, array);
});
var groupedDuplicatedArrays = function groupedDuplicatedArrays(serviceIdentifiers) {
  return groupBy(function (attribute) {
    return attribute.formValue;
  }, serviceIdentifiers);
};
var filterDuplicatedOnly = function filterDuplicatedOnly(attributesByValue) {
  var array = [];
  forEachObjIndexed(function (value) {
    if (value.length > 1) {
      array = array.concat(value);
    }
  }, attributesByValue);
  return array;
};
var ATTRIBUTE_CONSTANTS = {
  arrayOfAttributes: 'attributes',
  attributeId: 'id'
};
export var duplicatedServiceIdentifierAttributes = function duplicatedServiceIdentifierAttributes(attributeGroups) {
  return pipe(pluckBy(ATTRIBUTE_CONSTANTS.arrayOfAttributes), flatten, filterNonEmptyServiceIdentifiers, groupedDuplicatedArrays, filterDuplicatedOnly, pluckBy(ATTRIBUTE_CONSTANTS.attributeId))(attributeGroups);
};

// Handles Add Offer & New Connect flows.
export var getShoppingCartWithUpdatedStoreIdForAPIRequest = function getShoppingCartWithUpdatedStoreIdForAPIRequest(shoppingCart, storeId) {
  var shoppingCartForRequestObject = clone(shoppingCart);
  (shoppingCartForRequestObject.Items || []).forEach(function (item) {
    (item.PhysicalInventories || []).forEach(function (physicalInventory) {
      physicalInventory.StoreId = storeId;
    });
  });
  return shoppingCartForRequestObject;
};
export var buildSegmentationContext = function buildSegmentationContext(customerInfo) {
  return [{
    'Key': 'zipcode',
    'Value': customerInfo.postalCode
  }, {
    'Key': 'subscriber_category',
    'Value': customerInfo.Category
  }, {
    'Key': 'subscriber_type',
    'Value': customerInfo.SubscriberTypeCode
  }];
};
export var getMultiOfferShoppingCartWithUpdatedDeliveryDecision = function getMultiOfferShoppingCartWithUpdatedDeliveryDecision(shoppingCart, decisionType) {
  var shoppingCartForRequestObject = clone(shoppingCart);
  (shoppingCartForRequestObject.Items || []).forEach(function (item) {
    if (item.DeliveryType) {
      item.DeliveryType = decisionType;
    }
  });
  return {
    cartItems: shoppingCartForRequestObject,
    isAppend: false
  };
};